import React from 'react';
import "./feedback.css"

class Feedback extends React.Component {

    constructor(props){
        super(props)
        this.state={show:false}
        document.documentElement.style.setProperty("--feedback-div-pos", "-260px")
        document.documentElement.style.setProperty("--feedback-div-height", "70px")
        this.toogleFeedback.bind(this)
        this.sendFeedback.bind(this)
    }
    toogleFeedback(){
        this.state['show'] ? 
        document.documentElement.style.setProperty("--feedback-div-pos", "-260px"):
        document.documentElement.style.setProperty("--feedback-div-pos", "0px")
        
        this.state['show'] ? 
        document.documentElement.style.setProperty("--feedback-div-height", "70px"):
        document.documentElement.style.setProperty("--feedback-div-height", "470px")
        this.setState({show:!this.state.show})
    }
    sendFeedback(){
        let msg = document.getElementById("textarea").value
        if (msg.length === 0)
            document.getElementById("textarea").placeholder = 'Cannot submit an empty string. Please enter your feedback here...'
        else {
            const data = new FormData();
            data.append('page',this.props.history.location.pathname)
            data.append('msg',msg);
            fetch('/api/submitFeedback',
            {
                method: 'post',
                headers: {"Accept": "application/text"},
                mode: 'same-origin',
                body: data
            }).then (response => {
                if (response.ok) {
                    document.getElementById("textarea").value = ''
                    document.getElementById("textarea").placeholder = 'Feedback succesfully submitted !'
                }
                else {
                    document.getElementById("textarea").value = document.getElementById("textarea").value + "\n" +
                        "Error while submitting the message."
                }
            })
        }
    }

    render () {
        return (
        <div className="feedback_div">
            <div>
                <button className="btn btn-primary" onClick={()=> this.toogleFeedback()}>Feedback</button>
            </div>
            <div style={{height:"10px"}}></div>
            <div >
                <div> 
                <textarea rows = "12" cols = "36" style={{overflow:"visible",resize:"none"}} name = "feedback" id="textarea" placeholder="Enter your feedback here...">
                
                </textarea>
                <button className="btn btn-primary" onClick={()=> this.sendFeedback()}> Submit feedback</button>
                </div>
            
            </div>
        </div>
        )
    }
}
export default Feedback;